import { render } from "./elecBoardAnnealing.vue?vue&type=template&id=1b17b288"
import script from "./elecBoardAnnealing.vue?vue&type=script&lang=js"
export * from "./elecBoardAnnealing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__